{
  "REPORT": {
    "HEADER": "സംഭാഷണങ്ങൾ",
    "LOADING_CHART": "ചാർട്ട് ഡാറ്റ ലോഡു ചെയ്യുകയാണ്...",
    "NO_ENOUGH_DATA": "റിപ്പോർട്ട് സൃഷ്ടിക്കുന്നതിന് ആവശ്യമായ ഡാറ്റ ഞങ്ങൾക്ക് ലഭിച്ചിട്ടില്ല, ദയവായി പിന്നീട് വീണ്ടും ശ്രമിക്കുക.",
    "DOWNLOAD_CONVERSATION_REPORTS": "Download conversation reports",
    "DATA_FETCHING_FAILED": "Failed to fetch data, please try again later.",
    "SUMMARY_FETCHING_FAILED": "Failed to fetch summary, please try again later.",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "സംഭാഷണങ്ങൾ",
        "DESC": "(ആകെ)"
      },
      "INCOMING_MESSAGES": {
        "NAME": "ഇൻ‌കമിംഗ് സന്ദേശങ്ങൾ‌",
        "DESC": "( ആകെ )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "ഔട്ട് ഗോയിങ് സന്ദേശങ്ങൾ‌",
        "DESC": "( ആകെ )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "First Response Time",
        "DESC": "( ശരാശരി )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "First Response Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_TIME": {
        "NAME": "മിഴിവ് സമയം",
        "DESC": "( ശരാശരി )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "Resolution Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "മിഴിവ് എണ്ണം",
        "DESC": "( ആകെ )"
      },
      "BOT_RESOLUTION_COUNT": {
        "NAME": "മിഴിവ് എണ്ണം",
        "DESC": "(ആകെ)"
      },
      "BOT_HANDOFF_COUNT": {
        "NAME": "Handoff Count",
        "DESC": "(ആകെ)"
      },
      "REPLY_TIME": {
        "NAME": "Customer waiting time",
        "TOOLTIP_TEXT": "Waiting time is {metricValue} (based on {conversationCount} replies)",
        "DESC": ""
      }
    },
    "DATE_RANGE_OPTIONS": {
      "LAST_7_DAYS": "കഴിഞ്ഞ 7 ദിവസം",
      "LAST_14_DAYS": "കഴിഞ്ഞ 14 ദിവസം",
      "LAST_30_DAYS": "കഴിഞ്ഞ 30 ദിവസം",
      "THIS_MONTH": "This month",
      "LAST_MONTH": "Last month",
      "LAST_3_MONTHS": "കഴിഞ്ഞ 3 മാസം",
      "LAST_6_MONTHS": "കഴിഞ്ഞ 6 മാസം",
      "LAST_YEAR": "കഴിഞ്ഞ വർഷം",
      "CUSTOM_DATE_RANGE": "ഇഷ്‌ടാനുസൃത തീയതി ശ്രേണി"
    },
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "അപേക്ഷിക്കുക",
      "PLACEHOLDER": "തീയതി ശ്രേണി തിരഞ്ഞെടുക്കുക"
    },
    "GROUP_BY_FILTER_DROPDOWN_LABEL": "ഗ്രൂപ്പ് പ്രകാരം",
    "DURATION_FILTER_LABEL": "Duration",
    "GROUPING_OPTIONS": {
      "DAY": "ദിവസം",
      "WEEK": "ആഴ്ച",
      "MONTH": "മാസം",
      "YEAR": "വർഷം"
    },
    "GROUP_BY_DAY_OPTIONS": [
      {
        "id": 1,
        "groupBy": "ദിവസം"
      }
    ],
    "GROUP_BY_WEEK_OPTIONS": [
      {
        "id": 1,
        "groupBy": "ദിവസം"
      },
      {
        "id": 2,
        "groupBy": "ആഴ്ച"
      }
    ],
    "GROUP_BY_MONTH_OPTIONS": [
      {
        "id": 1,
        "groupBy": "ദിവസം"
      },
      {
        "id": 2,
        "groupBy": "ആഴ്ച"
      },
      {
        "id": 3,
        "groupBy": "മാസം"
      }
    ],
    "GROUP_BY_YEAR_OPTIONS": [
      {
        "id": 1,
        "groupBy": "ദിവസം"
      },
      {
        "id": 2,
        "groupBy": "ആഴ്ച"
      },
      {
        "id": 3,
        "groupBy": "മാസം"
      }
    ],
    "BUSINESS_HOURS": "Business Hours",
    "FILTER_ACTIONS": {
      "CLEAR_FILTER": "Clear filter",
      "EMPTY_LIST": "ഒരു ഫലവും കണ്ടെത്താനായില്ല"
    },
    "DRILLDOWN": {
      "TITLE": "{metric} details",
      "RESULT_COUNT_CONVERSATION": "{count} conversation | {count} conversations",
      "RESULT_COUNT_MESSAGE": "{count} message | {count} messages",
      "EMPTY": "No records found for this bar.",
      "ERROR": "Could not load records. Please try again.",
      "ADMIN_ONLY": "Only administrators can drill down into report records.",
      "LOAD_MORE": "Load more",
      "CLOSE": "Close details",
      "PREVIOUS_BUCKET": "Previous bar",
      "NEXT_BUCKET": "Next bar",
      "UNKNOWN_CONTACT": "Unknown contact",
      "UNKNOWN_INBOX": "Unknown inbox",
      "UNASSIGNED_AGENT": "നിയുക്തമാക്കാത്തത്",
      "NO_MESSAGE_CONTENT": "No message content",
      "MESSAGE_CREATED_AT": "Message created at {time}",
      "EVENT_OCCURRED_AT": "Event occurred at {time}",
      "INCOMING_MESSAGE": "Incoming message",
      "OUTGOING_MESSAGE": "Outgoing message"
    },
    "PAGINATION": {
      "RESULTS": "Showing {start} to {end} of {total} results",
      "PER_PAGE_TEMPLATE": "{size} / page"
    }
  },
  "AGENT_REPORTS": {
    "HEADER": "ഏജന്റുമാരുടെ അവലോകനം",
    "DESCRIPTION": "Easily track agent performance with key metrics such as conversations, response times, resolution times, and resolved cases. Click an agent's name to learn more.",
    "LOADING_CHART": "ചാർട്ട് ഡാറ്റ ലോഡു ചെയ്യുകയാണ്...",
    "NO_ENOUGH_DATA": "റിപ്പോർട്ട് സൃഷ്ടിക്കുന്നതിന് ആവശ്യമായ ഡാറ്റ ഞങ്ങൾക്ക് ലഭിച്ചിട്ടില്ല, ദയവായി പിന്നീട് വീണ്ടും ശ്രമിക്കുക.",
    "DOWNLOAD_AGENT_REPORTS": "ഏജന്റ് റിപ്പോർട്ടുകൾ ഡൗൺലോഡ് ചെയ്യുക",
    "FILTER_DROPDOWN_LABEL": "ഏജന്റ് തിരഞ്ഞെടുക്കുക",
    "FILTERS": {
      "INPUT_PLACEHOLDER": {
        "AGENTS": "ഏജന്റുകളെ തിരയുക"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "സംഭാഷണങ്ങൾ",
        "DESC": "(ആകെ)"
      },
      "INCOMING_MESSAGES": {
        "NAME": "ഇൻ‌കമിംഗ് സന്ദേശങ്ങൾ‌",
        "DESC": "(ആകെ)"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "ഔട്ട് ഗോയിങ് സന്ദേശങ്ങൾ‌",
        "DESC": "(ആകെ)"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "First Response Time",
        "DESC": "( ശരാശരി )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "First Response Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_TIME": {
        "NAME": "മിഴിവ് സമയം",
        "DESC": "( ശരാശരി )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "Resolution Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "മിഴിവ് എണ്ണം",
        "DESC": "(ആകെ)"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "കഴിഞ്ഞ 7 ദിവസം"
      },
      {
        "id": 1,
        "name": "കഴിഞ്ഞ 30 ദിവസം"
      },
      {
        "id": 2,
        "name": "കഴിഞ്ഞ 3 മാസം"
      },
      {
        "id": 3,
        "name": "കഴിഞ്ഞ 6 മാസം"
      },
      {
        "id": 4,
        "name": "കഴിഞ്ഞ വർഷം"
      },
      {
        "id": 5,
        "name": "ഇഷ്‌ടാനുസൃത തീയതി ശ്രേണി"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "അപേക്ഷിക്കുക",
      "PLACEHOLDER": "തീയതി ശ്രേണി തിരഞ്ഞെടുക്കുക"
    }
  },
  "LABEL_REPORTS": {
    "HEADER": "ലേബലുകൾ അവലോകനം",
    "DESCRIPTION": "Track label performance with key metrics including conversations, response times, resolution times, and resolved cases. Click a label name for detailed insights.",
    "LOADING_CHART": "ചാർട്ട് ഡാറ്റ ലോഡു ചെയ്യുകയാണ്...",
    "NO_ENOUGH_DATA": "റിപ്പോർട്ട് സൃഷ്ടിക്കുന്നതിന് ആവശ്യമായ ഡാറ്റ ഞങ്ങൾക്ക് ലഭിച്ചിട്ടില്ല, ദയവായി പിന്നീട് വീണ്ടും ശ്രമിക്കുക.",
    "DOWNLOAD_LABEL_REPORTS": "ലേബൽ റിപ്പോർട്ടുകൾ ഡൗൺലോഡ് ചെയ്യുക",
    "FILTER_DROPDOWN_LABEL": "ലേബൽ തിരഞ്ഞെടുക്കുക",
    "FILTERS": {
      "INPUT_PLACEHOLDER": {
        "LABELS": "ലേബലുകൾ തിരയുക"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "സംഭാഷണങ്ങൾ",
        "DESC": "(ആകെ)"
      },
      "INCOMING_MESSAGES": {
        "NAME": "ഇൻ‌കമിംഗ് സന്ദേശങ്ങൾ‌",
        "DESC": "(ആകെ)"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "ഔട്ട് ഗോയിങ് സന്ദേശങ്ങൾ‌",
        "DESC": "(ആകെ)"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "First Response Time",
        "DESC": "( ശരാശരി )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "First Response Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_TIME": {
        "NAME": "മിഴിവ് സമയം",
        "DESC": "( ശരാശരി )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "Resolution Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "മിഴിവ് എണ്ണം",
        "DESC": "(ആകെ)"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "കഴിഞ്ഞ 7 ദിവസം"
      },
      {
        "id": 1,
        "name": "കഴിഞ്ഞ 30 ദിവസം"
      },
      {
        "id": 2,
        "name": "കഴിഞ്ഞ 3 മാസം"
      },
      {
        "id": 3,
        "name": "കഴിഞ്ഞ 6 മാസം"
      },
      {
        "id": 4,
        "name": "കഴിഞ്ഞ വർഷം"
      },
      {
        "id": 5,
        "name": "ഇഷ്‌ടാനുസൃത തീയതി ശ്രേണി"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "അപേക്ഷിക്കുക",
      "PLACEHOLDER": "തീയതി ശ്രേണി തിരഞ്ഞെടുക്കുക"
    }
  },
  "INBOX_REPORTS": {
    "HEADER": "ഇൻബോക്സ് അവലോകനം",
    "DESCRIPTION": "Quickly view your inbox performance with key metrics like conversations, response times, resolution times, and resolved cases—all in one place. Click an inbox name for more details.",
    "LOADING_CHART": "ചാർട്ട് ഡാറ്റ ലോഡു ചെയ്യുകയാണ്...",
    "NO_ENOUGH_DATA": "റിപ്പോർട്ട് സൃഷ്ടിക്കുന്നതിന് ആവശ്യമായ ഡാറ്റ ഞങ്ങൾക്ക് ലഭിച്ചിട്ടില്ല, ദയവായി പിന്നീട് വീണ്ടും ശ്രമിക്കുക.",
    "DOWNLOAD_INBOX_REPORTS": "ഇൻബോക്സ് റിപ്പോർട്ടുകൾ ഡൗൺലോഡ് ചെയ്യുക",
    "FILTER_DROPDOWN_LABEL": "ഇൻബോക്സ് തിരഞ്ഞെടുക്കുക",
    "ALL_INBOXES": "All Inboxes",
    "SEARCH_INBOX": "Search Inbox",
    "FILTERS": {
      "INPUT_PLACEHOLDER": {
        "INBOXES": "Search inboxes"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "സംഭാഷണങ്ങൾ",
        "DESC": "(ആകെ)"
      },
      "INCOMING_MESSAGES": {
        "NAME": "ഇൻ‌കമിംഗ് സന്ദേശങ്ങൾ‌",
        "DESC": "(ആകെ)"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "ഔട്ട് ഗോയിങ് സന്ദേശങ്ങൾ‌",
        "DESC": "(ആകെ)"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "First Response Time",
        "DESC": "( ശരാശരി )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "First Response Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_TIME": {
        "NAME": "മിഴിവ് സമയം",
        "DESC": "( ശരാശരി )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "Resolution Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "മിഴിവ് എണ്ണം",
        "DESC": "(ആകെ)"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "കഴിഞ്ഞ 7 ദിവസം"
      },
      {
        "id": 1,
        "name": "കഴിഞ്ഞ 30 ദിവസം"
      },
      {
        "id": 2,
        "name": "കഴിഞ്ഞ 3 മാസം"
      },
      {
        "id": 3,
        "name": "കഴിഞ്ഞ 6 മാസം"
      },
      {
        "id": 4,
        "name": "കഴിഞ്ഞ വർഷം"
      },
      {
        "id": 5,
        "name": "ഇഷ്‌ടാനുസൃത തീയതി ശ്രേണി"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "അപേക്ഷിക്കുക",
      "PLACEHOLDER": "തീയതി ശ്രേണി തിരഞ്ഞെടുക്കുക"
    }
  },
  "TEAM_REPORTS": {
    "HEADER": "ടീം അവലോകനം",
    "DESCRIPTION": "Get a snapshot of your team's performance with essential metrics, including conversations, response times, resolution times, and resolved cases. Click a team name for more details.",
    "LOADING_CHART": "ചാർട്ട് ഡാറ്റ ലോഡു ചെയ്യുകയാണ്...",
    "NO_ENOUGH_DATA": "റിപ്പോർട്ട് സൃഷ്ടിക്കുന്നതിന് ആവശ്യമായ ഡാറ്റ ഞങ്ങൾക്ക് ലഭിച്ചിട്ടില്ല, ദയവായി പിന്നീട് വീണ്ടും ശ്രമിക്കുക.",
    "DOWNLOAD_TEAM_REPORTS": "ടീം റിപ്പോർട്ടുകൾ ഡൗൺലോഡ് ചെയ്യുക",
    "FILTER_DROPDOWN_LABEL": "ടീം തിരഞ്ഞെടുക്കുക",
    "FILTERS": {
      "ADD_FILTER": "ഫിൽട്ടർ ചേർക്കുക",
      "CLEAR_ALL": "Clear all",
      "NO_FILTER": "No filters available",
      "INPUT_PLACEHOLDER": {
        "TEAMS": "ടീമുകളെ തിരയുക"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "സംഭാഷണങ്ങൾ",
        "DESC": "(ആകെ)"
      },
      "INCOMING_MESSAGES": {
        "NAME": "ഇൻ‌കമിംഗ് സന്ദേശങ്ങൾ‌",
        "DESC": "(ആകെ)"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "ഔട്ട് ഗോയിങ് സന്ദേശങ്ങൾ‌",
        "DESC": "(ആകെ)"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "First Response Time",
        "DESC": "( ശരാശരി )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "First Response Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_TIME": {
        "NAME": "മിഴിവ് സമയം",
        "DESC": "( ശരാശരി )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "Resolution Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "മിഴിവ് എണ്ണം",
        "DESC": "(ആകെ)"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "കഴിഞ്ഞ 7 ദിവസം"
      },
      {
        "id": 1,
        "name": "കഴിഞ്ഞ 30 ദിവസം"
      },
      {
        "id": 2,
        "name": "കഴിഞ്ഞ 3 മാസം"
      },
      {
        "id": 3,
        "name": "കഴിഞ്ഞ 6 മാസം"
      },
      {
        "id": 4,
        "name": "കഴിഞ്ഞ വർഷം"
      },
      {
        "id": 5,
        "name": "ഇഷ്‌ടാനുസൃത തീയതി ശ്രേണി"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "അപേക്ഷിക്കുക",
      "PLACEHOLDER": "തീയതി ശ്രേണി തിരഞ്ഞെടുക്കുക"
    }
  },
  "CSAT_REPORTS": {
    "HEADER": "CSAT റിപ്പോർട്ടുകൾ",
    "NO_RECORDS": "No responses yet",
    "NO_RECORDS_DESCRIPTION": "CSAT survey responses will appear here once customers start providing feedback.",
    "DOWNLOAD": "Download CSAT Reports",
    "DOWNLOAD_FAILED": "Failed to download CSAT Reports",
    "FILTERS": {
      "ADD_FILTER": "ഫിൽട്ടർ ചേർക്കുക",
      "CLEAR_ALL": "Clear all",
      "NO_FILTER": "No filters available",
      "INPUT_PLACEHOLDER": {
        "AGENTS": "ഏജന്റുകളെ തിരയുക",
        "INBOXES": "Search inboxes",
        "TEAMS": "ടീമുകളെ തിരയുക",
        "RATINGS": "Search ratings"
      },
      "AGENTS": {
        "LABEL": "ഏജന്റ്"
      },
      "INBOXES": {
        "LABEL": "ഇൻബോക്സ്"
      },
      "TEAMS": {
        "LABEL": "Team"
      },
      "RATINGS": {
        "LABEL": "Rating"
      }
    },
    "TABLE": {
      "HEADER": {
        "CONTACT_NAME": "ബന്ധപ്പെടുക",
        "AGENT_NAME": "ഏജന്റ്",
        "RATING": "റേറ്റിംഗ്",
        "FEEDBACK_TEXT": "ഫീഡ്ബാക്ക് അഭിപ്രായം",
        "CONVERSATION": "സംഭാഷണം",
        "CUSTOMER": "Customer",
        "RESPONSE": "Response",
        "HANDLED_BY": "Handled by"
      },
      "UNKNOWN_CUSTOMER": "Unknown customer"
    },
    "NO_AGENT": "No assigned agent",
    "NO_FEEDBACK": "No feedback provided",
    "METRIC": {
      "TOTAL_RESPONSES": {
        "LABEL": "ആകെ പ്രതികരണങ്ങൾ",
        "TOOLTIP": "ശേഖരിച്ച പ്രതികരണങ്ങളുടെ ആകെ എണ്ണം"
      },
      "SATISFACTION_SCORE": {
        "LABEL": "സംതൃപ്തി സ്കോർ",
        "TOOLTIP": "പോസിറ്റീവ് പ്രതികരണങ്ങളുടെ ആകെ എണ്ണം / പ്രതികരണങ്ങളുടെ ആകെ എണ്ണം * 100"
      },
      "RESPONSE_RATE": {
        "LABEL": "പ്രതികരണ നിരക്ക്",
        "TOOLTIP": "മൊത്തം പ്രതികരണങ്ങളുടെ എണ്ണം / അയച്ച CSAT സർവേ സന്ദേശങ്ങളുടെ ആകെ എണ്ണം * 100"
      },
      "RATING_DISTRIBUTION": "Rating distribution"
    },
    "REVIEW_NOTES": {
      "TITLE": "Review notes",
      "PLACEHOLDER": "Add review notes about this rating...",
      "SAVE": "Save",
      "CANCEL": "റദ്ദാക്കുക",
      "SAVING": "Saving...",
      "SAVED": "Notes saved successfully",
      "SAVE_ERROR": "Failed to save notes",
      "UPDATED_BY": "Updated by {name} {time}",
      "UPDATED_BY_LABEL": "Updated by",
      "PAYWALL": {
        "TITLE": "Upgrade to add review notes",
        "AVAILABLE_ON": "The review notes feature is only available in the Business and Enterprise plans.",
        "UPGRADE_PROMPT": "Add internal context to every CSAT response with review notes. Capture what really happened, spot patterns faster, and make better decisions from your feedback.",
        "UPGRADE_NOW": "Upgrade now",
        "CANCEL_ANYTIME": "You can change or cancel your plan anytime"
      }
    }
  },
  "BOT_REPORTS": {
    "HEADER": "Bot Reports",
    "METRIC": {
      "TOTAL_CONVERSATIONS": {
        "LABEL": "No. of Conversations",
        "TOOLTIP": "Total number of conversations handled by the bot"
      },
      "TOTAL_RESPONSES": {
        "LABEL": "Total Responses",
        "TOOLTIP": "Total number of responses sent by the bot"
      },
      "RESOLUTION_RATE": {
        "LABEL": "Resolution Rate",
        "TOOLTIP": "Total number of conversations resolved by the bot / Total number of conversations handled by the bot * 100"
      },
      "HANDOFF_RATE": {
        "LABEL": "Handoff Rate",
        "TOOLTIP": "Total number of conversations handed off to agents / Total number of conversations handled by the bot * 100"
      }
    }
  },
  "OVERVIEW_REPORTS": {
    "HEADER": "അവലോകനം",
    "LIVE": "Live",
    "ACCOUNT_CONVERSATIONS": {
      "HEADER": "Open Conversations",
      "LOADING_MESSAGE": "Loading conversation metrics...",
      "OPEN": "സജീവം",
      "UNATTENDED": "Unattended",
      "UNASSIGNED": "നിയുക്തമാക്കാത്തത്",
      "PENDING": "കെട്ടിക്കിടക്കുന്നു"
    },
    "CONVERSATION_HEATMAP": {
      "HEADER": "Conversation Traffic",
      "NO_CONVERSATIONS": "No conversations",
      "CONVERSATION": "{count} conversation",
      "CONVERSATIONS": "{count} conversations",
      "DOWNLOAD_REPORT": "Download report"
    },
    "RESOLUTION_HEATMAP": {
      "HEADER": "Resolutions",
      "NO_CONVERSATIONS": "No conversations",
      "CONVERSATION": "{count} conversation",
      "CONVERSATIONS": "{count} conversations",
      "DOWNLOAD_REPORT": "Download report"
    },
    "AGENT_CONVERSATIONS": {
      "HEADER": "Conversations by agents",
      "LOADING_MESSAGE": "Loading agent metrics...",
      "NO_AGENTS": "There are no conversations by agents",
      "TABLE_HEADER": {
        "AGENT": "ഏജന്റ്",
        "OPEN": "സജീവം",
        "UNATTENDED": "Unattended",
        "STATUS": "സ്റ്റാറ്റസ്"
      }
    },
    "TEAM_CONVERSATIONS": {
      "ALL_TEAMS": "All Teams",
      "HEADER": "Conversations by teams",
      "LOADING_MESSAGE": "Loading team metrics...",
      "NO_TEAMS": "There is no data available",
      "TABLE_HEADER": {
        "TEAM": "Team",
        "OPEN": "സജീവം",
        "UNATTENDED": "Unattended",
        "STATUS": "സ്റ്റാറ്റസ്"
      }
    },
    "AGENT_STATUS": {
      "HEADER": "Agent status",
      "ONLINE": "ഓൺ‌ലൈൻ",
      "BUSY": "തിരക്ക്",
      "OFFLINE": "ഓഫ്‌ലൈൻ"
    }
  },
  "DAYS_OF_WEEK": {
    "SUNDAY": "Sunday",
    "MONDAY": "Monday",
    "TUESDAY": "Tuesday",
    "WEDNESDAY": "Wednesday",
    "THURSDAY": "Thursday",
    "FRIDAY": "Friday",
    "SATURDAY": "Saturday"
  },
  "SLA_REPORTS": {
    "HEADER": "SLA Reports",
    "NO_RECORDS": "SLA applied conversations are not available.",
    "LOADING": "Loading SLA data...",
    "DOWNLOAD_SLA_REPORTS": "Download SLA reports",
    "DOWNLOAD_FAILED": "Failed to download SLA Reports",
    "DROPDOWN": {
      "ADD_FIlTER": "ഫിൽട്ടർ ചേർക്കുക",
      "CLEAR_ALL": "Clear all",
      "CLEAR_FILTER": "Clear filter",
      "EMPTY_LIST": "ഒരു ഫലവും കണ്ടെത്താനായില്ല",
      "NO_FILTER": "No filters available",
      "SEARCH": "Search filter",
      "INPUT_PLACEHOLDER": {
        "SLA": "SLA name",
        "AGENTS": "Agent name",
        "INBOXES": "Inbox name",
        "LABELS": "ലേബൽ നാമം",
        "TEAMS": "ടീമിന്റെ പേര്"
      },
      "SLA": "SLA Policy",
      "INBOXES": "ഇൻബോക്സ്",
      "AGENTS": "ഏജന്റ്",
      "LABELS": "Label",
      "TEAMS": "Team"
    },
    "WITH": "with",
    "METRICS": {
      "HIT_RATE": {
        "LABEL": "Hit Rate",
        "TOOLTIP": "Percentage of SLAs created were completed successfully"
      },
      "NO_OF_MISSES": {
        "LABEL": "Number of Misses",
        "TOOLTIP": "Total SLA misses in a certain period"
      },
      "NO_OF_CONVERSATIONS": {
        "LABEL": "Number of Conversations",
        "TOOLTIP": "Total number of conversations with SLA"
      }
    },
    "TABLE": {
      "HEADER": {
        "POLICY": "Policy",
        "CONVERSATION": "സംഭാഷണം",
        "AGENT": "ഏജന്റ്"
      },
      "VIEW_DETAILS": "View Details"
    }
  },
  "SUMMARY_REPORTS": {
    "INBOX": "ഇൻബോക്സ്",
    "AGENT": "ഏജന്റ്",
    "TEAM": "Team",
    "LABEL": "Label",
    "AVG_RESOLUTION_TIME": "Avg. Resolution Time",
    "AVG_FIRST_RESPONSE_TIME": "Avg. First Response Time",
    "AVG_REPLY_TIME": "Avg. Customer Waiting Time",
    "RESOLUTION_COUNT": "മിഴിവ് എണ്ണം",
    "CONVERSATIONS": "No. of conversations"
  }
}
